import React from 'react'

const SvgComponent = props => (
  <svg width={60} height={60} {...props}>
    <defs>
      <linearGradient
        x1="28.17%"
        y1="24.841%"
        x2="155.653%"
        y2="90.79%"
        id="leader__prefix__a"
      >
        <stop stopColor="#F57B94" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="270.409%"
        y2="172.34%"
        id="leader__prefix__b"
      >
        <stop stopColor="#F6B4C2" offset="0%" />
        <stop stopColor="#F6708E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="leader__prefix__c"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#leader__prefix__a)"
        d="M49.152 17.273l1.757-9.437L49.152 0H29.09l8.788 8.694-8.788 8.579z"
      />
      <path fill="url(#leader__prefix__b)" d="M49.09 0h3.637v31.818h-3.636z" />
      <path
        fill="url(#leader__prefix__c)"
        d="M42.305 28.182v7.044H28.242v7.045H14.18v7.045H0V60h60V28.182z"
      />
      <path fill="url(#leader__prefix__b)" d="M50.91 28.182H60V60h-9.09z" />
    </g>
  </svg>
)

export default SvgComponent
